import { watch } from 'vue';
import { defineNuxtPlugin } from '#app';
import { useConfig } from '~/composables/useConfig';

type JimoQueue = Array<[string, string, (string | number | object | boolean)[]]>;

export default defineNuxtPlugin(() => {
  if (import.meta.server) return;

  if (typeof navigator !== 'undefined' && navigator.webdriver) {
    return;
  }

  const config = useConfig();

  const initJimo = (publicConfig: Record<string, unknown>) => {
    const projectId =
      typeof publicConfig.jimoProjectId === 'string' ? publicConfig.jimoProjectId.trim() : '';

    if (
      !projectId ||
      projectId === 'undefined' ||
      projectId === 'null' ||
      typeof window === 'undefined' ||
      window.jimo != null
    )
      return;

    window.jimo = [] as JimoQueue;
    window.JIMO_PROJECT_ID = projectId;

    const identifyUser = () => {
      const userId = localStorage.getItem('userId') || undefined;
      if (!userId) return;

      const username = localStorage.getItem('username') || undefined;

      window.jimo?.push([
        'do',
        'identify',
        [
          userId,
          () => {
            if (username) window.jimo?.push(['set', 'user:name', [username]]);
          }
        ]
      ]);
    };

    identifyUser();
    window.addEventListener('jimo:identify', identifyUser);

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://undercity.usejimo.com/jimo-invader.js';
    document.head.appendChild(script);
  };

  watch(
    () => config.value?.public,
    (publicConfig) => {
      if (!publicConfig) return;
      initJimo(publicConfig as unknown as Record<string, unknown>);
    },
    { immediate: true }
  );
});
